import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from './api';

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const track = async () => {
      try {
        await api.post('/analytics/pageview', {
          path: location.pathname,
          referrer: document.referrer || '',
        });
      } catch {
        // Silent fail — tracking should never break the app
      }
    };
    track();
  }, [location.pathname]);
}
